import { CSSProperties } from 'react';
import { observer } from 'mobx-react';

import { MEDIA_SIZE_LARGE, MediaSize } from '@/media/constants/sizeCodes';
import { MEDIA_SIZE_MAP } from '@/media/constants/sizeCodeToPx';
import { setupPresetRepository } from '@/media/repository/SetupPresetRepository';
import Diamond from '@/product/entity/Diamond';

import DeadZoneMetric from '../../entity/DeadZoneMetric';
import FireMetric from '../../entity/FireMetric';
import ScintillationMetric from '../../entity/ScintillationMetric';

import styles from './MetricMap.module.css';

interface MetricMapProps {
  product: Diamond;
  mediaSize?: MediaSize;
  maxScale?: Nullable<number>;
  isSingleScaleEnabled?: Nullable<boolean>;
  setupPresetId: number;
  metric: Nullable<FireMetric | ScintillationMetric | DeadZoneMetric>;
  'aria-label'?: string;
}

function MetricMap(props: MetricMapProps) {
  const {
    product,
    mediaSize = MEDIA_SIZE_LARGE,
    maxScale = null,
    isSingleScaleEnabled = false,
    setupPresetId,
    metric,
    'aria-label': ariaLabel = 'Metric map chart',
  } = props;

  function getSize() {
    let size = MEDIA_SIZE_MAP[mediaSize];

    if (isSingleScaleEnabled && maxScale) {
      const sp = setupPresetRepository.findSetupPresetById(setupPresetId);
      const media = product.mediaCollection ? product.mediaCollection.getMediaBySetupPreset(sp) : null;
      const mainMediaSource = media ? media.mainMediaSource : null;

      if (mainMediaSource && mainMediaSource.scaleRatio) {
        size *= mainMediaSource.getRelScale(mainMediaSource.getMaxSubFileByMediaSize(size)!) / maxScale;
      }
    }

    return size;
  }

  if (!metric || !metric.map) {
    return null;
  }

  return (
    <div className={styles.metricMap} aria-label={ariaLabel} style={{ '--metric-map-size': `${getSize()}px` } as CSSProperties}>
      <img src={metric.map} alt="Metric Map" />
    </div>
  );
}

export default observer(MetricMap);
